'use strict';

module.exports['round'] = require('./locutus-php-round');



//////////////////
// WEBPACK FOOTER
// /var/www/apps.frsfulfillment.com/resources/assets/js/components/frontend/util/index.js
// module id = LcvD
// module chunks = 1